import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=a944db9e&scoped=true"
import script from "./Dealers.vue?vue&type=script&lang=js"
export * from "./Dealers.vue?vue&type=script&lang=js"
import style0 from "./Dealers.vue?vue&type=style&index=0&id=a944db9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a944db9e",
  null
  
)

export default component.exports